import { Grid, Typography, Button } from '@mui/material'
import { Box, Container, keyframes } from '@mui/system'
import React from 'react'
import Navbar from '../../components/Navbar'
import { useNavigate } from 'react-router-dom'


const jump = keyframes`
  0%   { transform: translateY(0); }
  50%  { transform: translateY(-50px); }
  100% { transform: translateY(0); }
`

const NotFound = () => {
	const navigate = useNavigate()
	return (
		<div>
			<Navbar></Navbar>
			<Box sx={{ backgroundColor: "#f6f7ff", minHeight: "93vh", }}>
				<Container maxWidth="xl" sx={{ display: "flex", alignItems: "center", minHeight: "93vh", }}>
					<Grid container spacing={2} sx={{ alignItems: "center", }}>
						<Grid item xs={6}>
							<Box>
								<Typography color={"primary"} sx={{ fontSize: "110px", lineHeight: "90px", fontWeight: "600", }}>404</Typography>
							</Box>
							<Box sx={{ mt: 3 }}>
								<Typography color={"primary"} sx={{ fontSize: "34px", lineHeight: "35px", fontWeight: "600" }}>OPPS! PAGE NOT FOUND</Typography>
							</Box>
							<Box sx={{ mt: 2 }}>
								<Typography sx={{ fontSize: "20px", }}>Sorry, the page you're looking for doesn't exist. if you think something is broken, report a problem.</Typography>
							</Box>
							<Box sx={{ mt: 3 }}>
								<Button onClick={() => { navigate('/') }} variant='outlined' size='large' type="submit" style={{ fontSize: "20px", textTransform: "capitalize" }}>Return Home</Button>
							</Box>
						</Grid>
						<Grid item xs={6}>
							<Box sx={{ textAlign: "center", animation: `${jump} 4s linear infinite`, }}>
								<img style={{ width: "95%", }} src={process.env.PUBLIC_URL + "/assets/error-404.svg"} alt="" />
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Box>
		</div>
	)
}

export default NotFound